import React, { useState } from "react";
import { formatTime } from "../utils/helpers";
import { useSessionManager } from "../utils/sessionManager";
import InlineTaskForm from "./InlineTaskForm";

// Utility function to safely format dates
const safeFormatDate = (dateString) => {
  if (!dateString) return "Unknown";
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "Unknown";
  return date.toLocaleDateString();
};

const TaskItem = ({
  task,
  projectName,
  projectColor,
  onDelete,
  onUpdate,
  projects,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  // Use session manager to get real-time time calculation
  const { stats } = useSessionManager(task.id);

  const handleStatusChange = (newStatus) => {
    console.log("🔄 TaskItem: Status change requested");
    console.log("  📋 Task ID:", task.id);
    console.log("  📊 Current Status:", task.status);
    console.log("  🎯 New Status:", newStatus);

    onUpdate({
      ...task,
      status: newStatus,
    });

    console.log("  ✅ Status update sent to parent");
  };

  const handleDelete = () => {
    if (window.confirm(`Delete task "${task.title}"?`)) {
      onDelete(task.id);
    }
  };

  // Debug logging
  console.log("🔍 TaskItem: Rendering task");
  console.log("  📋 Task:", task);
  console.log("  🎨 Project Color:", projectColor);
  console.log("  📊 Task Status:", task.status);
  console.log("  ✅ Is Completed:", task.status === "completed");
  console.log(
    "  📅 Created At:",
    task.createdAt,
    "Type:",
    typeof task.createdAt
  );
  console.log(
    "  📅 Updated At:",
    task.updatedAt,
    "Type:",
    typeof task.updatedAt
  );
  console.log(
    "  🎯 Project Indicator Class:",
    `project-indicator ${task.status === "completed" ? "completed" : ""}`
  );
  console.log("  🎨 Project Indicator Style:", {
    backgroundColor: projectColor,
  });

  return (
    <div className={`task-item ${task.status} ${isEditing ? "editing" : ""}`}>
      <div className="task-header" onClick={() => setIsExpanded(!isExpanded)}>
        <div className="task-info">
          <div
            className={`project-indicator ${
              task.status === "completed" ? "completed" : ""
            }`}
            style={{ backgroundColor: projectColor || "#97feed" }}
            onClick={(e) => {
              e.stopPropagation();
              console.log("🖱️ Project indicator clicked");
              const newStatus =
                task.status === "completed" ? "todo" : "completed";
              handleStatusChange(newStatus);
            }}
            title={`Click to mark as ${
              task.status === "completed" ? "todo" : "completed"
            }`}
          >
            {task.status === "completed" && (
              <span className="checkmark">✓</span>
            )}
          </div>
          <div className="task-details">
            <h4 className="task-title">{task.title}</h4>
            <div className="task-meta">
              <span className="task-category">{task.category}</span>
              <span className="task-time">{formatTime(stats.totalTime)}</span>
            </div>
          </div>
        </div>

        <div className="task-actions">
          <button
            className="edit-btn"
            onClick={(e) => {
              e.stopPropagation();
              setIsEditing(true);
            }}
          >
            Edit
          </button>
          <button
            className="delete-btn"
            onClick={(e) => {
              e.stopPropagation();
              handleDelete();
            }}
          >
            Delete
          </button>
        </div>
      </div>

      {isExpanded && (
        <div className="task-expanded">
          {task.description && (
            <div className="task-description">
              <h5>Description:</h5>
              <div className="description-text">{task.description}</div>
            </div>
          )}

          <div className="task-stats">
            <div className="stat">
              <span className="stat-label">Created:</span>
              <span className="stat-value">
                {safeFormatDate(task.createdAt)}
              </span>
            </div>
            <div className="stat">
              <span className="stat-label">Updated:</span>
              <span className="stat-value">
                {safeFormatDate(task.updatedAt)}
              </span>
            </div>
            <div className="stat">
              <span className="stat-label">Time Tracked:</span>
              <span className="stat-value">{formatTime(stats.totalTime)}</span>
            </div>
          </div>
        </div>
      )}

      {isEditing && (
        <div className="task-edit-form">
          <InlineTaskForm
            editingTask={task}
            onSave={async (taskData) => {
              await onUpdate(taskData);
              setIsEditing(false);
            }}
            onCancel={() => setIsEditing(false)}
            projects={projects}
          />
        </div>
      )}
    </div>
  );
};

export default TaskItem;
